import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { GroupedBracketedDiv } from "../Logic/AndGroupEditor";
import { ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import { DateGreaterThanExpression } from "../../../rule-engine-core/Expressions/Expressions/Date/DateGreaterThanExpression";

export class DateGreaterThanExpressionEditor extends ExpressionRuleEditor<DateGreaterThanExpression> {
    render() {
        return (
            <GroupedBracketedDiv issue={this.ruleData!.getValidationIssues()[0]}>
                <ExpressionPiece hasChild={!!this.ruleData!.value1!.subExpression}>
                    <ExpressionValueRenderer el={this.ruleData!.value1!} />
                </ExpressionPiece>
                <ExpressionPiece> {">"} </ExpressionPiece>
                <ExpressionPiece hasChild={!!this.ruleData!.value2!.subExpression}>
                    <ExpressionValueRenderer el={this.ruleData!.value2!} />
                </ExpressionPiece>
            </GroupedBracketedDiv>
        );
    }
}
